import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.min'
import '@/editor/editor-content.css'
import VueRouter from 'vue-router'
import Routes from './routes'
import TranslationFilter from "@/filters/TranslationFilter";
import StaticTranslationFilter from "@/filters/StaticTranslationFilter";
import wysiwyg from "vue-wysiwyg";
import TimeFilter from "@/filters/TimeFilter";
import DateFilter from "@/filters/DateFilter";
import DateWithNameFilter from "@/filters/DateWithNameFilter";
import DateIdFilter from "@/filters/DateIdFilter";
import SubstringFilter from "@/filters/SubstringFilter";
import VueParallaxJs from 'vue-parallax-js'
import axios from "@/api/axiom-instance";

Vue.use(VueParallaxJs)
Vue.use(VueRouter);
Vue.use(wysiwyg, {});

Vue.filter("translation", TranslationFilter)
Vue.filter("staticTranslation", StaticTranslationFilter)
Vue.filter("time", TimeFilter)
Vue.filter("date", DateFilter)
Vue.filter("dateWithName", DateWithNameFilter)
Vue.filter("dateId", DateIdFilter)
Vue.filter("substring", SubstringFilter)

function waitForPageHeight(y, timeout = 2000) {
    return new Promise(resolve => {
        const deadline = Date.now() + timeout
        const check = () => {
            const tallEnough = document.documentElement.scrollHeight - window.innerHeight >= y
            if (tallEnough || Date.now() >= deadline) {
                resolve()
                return
            }
            setTimeout(check, 50)
        }
        check()
    })
}

const router = new VueRouter({
    mode: 'history',
    routes: Routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return waitForPageHeight(savedPosition.y).then(() => savedPosition)
        }
        if (to.hash) {
            return {selector: to.hash}
        }
        return {x: 0, y: 0}
    }
});

router.beforeEach((to, from, next) => {
    if (!to.matched.some(route => route.meta && route.meta.requiresAuth)) {
        next()
        return
    }

    axios.get("/auth/status").then((response) => {
        if (response.status === 204) {
            next()
            return
        }
        next({path: "/login", query: {redirect: to.fullPath}})
    }).catch(() => {
        next({path: "/login", query: {redirect: to.fullPath}})
    })
});

new Vue({
    render: h => h(App),
    router: router
}).$mount('#app')
